import { ThemeProvider } from '@mui/material';
import { ReactNode, useEffect } from 'react';
import { darkTheme, lightFullTheme, lightTheme } from './mui-theme';
import { useUiStore } from './stores/ui.store';
import { isDarkThemeMode } from './theme-mode';

interface AppThemeProviderProps {
  children: ReactNode;
}

/**
 * Applies the persisted theme mode to MUI and the document `data-theme` attribute
 * so CSS-variable theming in ui.css stays in sync with the MUI palette.
 */
export function AppThemeProvider({ children }: AppThemeProviderProps) {
  const themeMode = useUiStore((state) => state.themeMode);
  const isDark = isDarkThemeMode(themeMode);

  useEffect(() => {
    if (isDark) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }, [isDark]);

  const muiTheme =
    themeMode === 'dark' ? darkTheme : themeMode === 'light-full' ? lightFullTheme : lightTheme;

  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
}
